import { render, staticRenderFns } from "./work_order.vue?vue&type=template&id=0c05794e&scoped=true&"
import script from "./work_order.vue?vue&type=script&lang=js&"
export * from "./work_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c05794e",
  null
  
)

export default component.exports